import React from "react";
import Stars from "~/common/Stars";
import { getTotalRatings } from "../../CustomerReviewHelper";
import { CustomerReviews } from "../../reviewModels";
interface ReviewsOverallRatingProps {
  reviews: CustomerReviews;
  aiSummaryText: string;
  isProductReviewPage?: boolean;
}
const ReviewsOverallRating = ({
  reviews,
  aiSummaryText,
  isProductReviewPage
}: ReviewsOverallRatingProps) => {
  const totalReviews = getTotalRatings(reviews.productReviewDetails).length;
  const hasRating = totalReviews > 0 && reviews.overallRating > 0;
  return <div className={`review-rating-overall ${isProductReviewPage ? "w-1/2 border-r xs:border-r-0 border-l-0 border-t-0 border-b-0 lt:flex lt:justify-center lt:items-center px-5 xs:px-6 lt:pl-6 lt:pr-8" : "border-r-0 border-l-0 border-t-0 border-b xs:border-b-0 xs:px-5 py-8 xs:py-0 xxxl:pl-0 xxxl:pr-8"} border border-solid border-gray-200 ${!aiSummaryText ? "xxxl:w-1/3" : "xxxl:w-1/5"}`} data-sentry-component="ReviewsOverallRating" data-sentry-source-file="index.tsx">
      <div className={isProductReviewPage ? "py-4 xs:py-0" : ""}>
        <p className={`${isProductReviewPage ? "text-4xl xs:text-5xl" : "text-5xl"} font-bold text-gray-800 mb-0`}>
          {hasRating ? reviews.overallRating.toFixed(1) : <span>Not Rated</span>}
        </p>
        {hasRating && <Stars rating={reviews.overallRating} size="extraLarge" containerClasses="py-2" />}
        <p className={`${isProductReviewPage ? "text-sm xs:text-base" : "text-base text-gray-700"} m-0`}>
          {hasRating ? <span>{totalReviews} Customer Reviews</span> : null}
        </p>
      </div>
    </div>;
};
export default ReviewsOverallRating;